<div class="photo">
  <mat-chip-set>
    @if (image) {
      <mat-chip
        disabled
        class="user-img"
        [ngStyle]="{
          'background-image': 'url(' + image + ')',
          'width': size,
          'height': size
        }"
      ></mat-chip>
    }
    @if (!image) {
      <mat-chip
        [ngStyle]="{
          'width': size,
          'height': size,
          'font-size': 'calc(' + size + ' * 0.5)'
        }"
        disabled
      >{{ userInitials }}</mat-chip>
    }
  </mat-chip-set>
</div> 
